import { cn } from "@/lib/utils";
import type { Status } from "#shared/types";

const styles: Record<Status, { label: string; className: string }> = {
  out: { label: "Inte här", className: "bg-muted text-muted-foreground" },
  working: { label: "Arbetar", className: "bg-success/15 text-success" },
  lunch: { label: "På lunch", className: "bg-warning/20 text-warning-foreground" },
  done: { label: "Klar för dagen", className: "bg-primary/12 text-primary" },
};

export function StatusChip({ status, className }: { status: Status; className?: string }) {
  const style = styles[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold",
        style.className,
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {style.label}
    </span>
  );
}
